<template>
  <div>
    <div style="width: 700px; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div class="printItem">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3" style="width: 110px">
              <div id="qrCode" align="center" />
            </td>
            <td colspan="3">工单</td>
          </tr>
          <tr>
            <td colspan="3">派工单号：{{ orderDetail.billNo }}</td>
          </tr>
          <tr>
            <td colspan="3">物料编号：{{ orderDetail.materialNo }}</td>
          </tr>
          <tr>
            <td colspan="2">物料名称：{{ orderDetail.materialName }}</td>
            <td colspan="2">物料规格：{{ orderDetail.specification }}</td>
          </tr>
          <tr>
            <td colspan="2">工艺路线：{{ orderDetail.routingName }}</td>
            <td colspan="2">生产中心：{{ orderDetail.workCenterName }}</td>
          </tr>
          <tr>
            <td colspan="2">工单数量：{{ orderDetail.quantity }}</td>
            <td colspan="2">工艺类型：{{ orderDetail.prodOrderTypeName }}</td>
          </tr>
          <tr>
            <td colspan="2">开工时间：{{ orderDetail.planStartTime }}</td>
            <td colspan="2">完工时间：{{ orderDetail.planFinishTime }}</td>
          </tr>
          <tr>
            <td colspan="2">销售单号：{{ orderDetail.salesOrderNo }}</td>
            <td colspan="2">ERP单号：{{ orderDetail.erpSalesOrderNo }}</td>
          </tr>
          <tr>
            <td colspan="2">合同号：{{ orderDetail.customerContractNo }}</td>
            <td colspan="2">项目名称：{{ orderDetail.projectName }}</td>
          </tr>
          <tr>
            <td colspan="4">客户名称：{{ orderDetail.customerName }}</td>
          </tr>
          <tr>
            <td colspan="4">订单备注：{{ orderDetail.salesOrderMaterialNote }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      orderDetail: {},
    };
  },

  mounted() {
    this.orderDetail = JSON.parse(this.$route.query.params);
    this.$nextTick(() => {
      document.getElementById("qrCode").innerHTML = "";
      this.bindQRCode(this.orderDetail.billNo);
    });
  },

  methods: {
    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode"), {
        text: code,
        width: 110,
        height: 110,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 700px;
  border: 1px solid #111;
  font-size: 10px;
  margin: 0 auto;
  table {
    width: 100%;
    tr {
      td {
        border-bottom: 1px solid #111;
        border-right: 1px solid #111;
        padding: 10px 5px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
